module.exports = __webpack_public_path__ + "img/更多设计类.4730b51d.png";